import { Injectable } from '@angular/core';
import { Observable , BehaviorSubject} from 'rxjs';

import { ApiService } from "../../shared/services/api.service";
import { FormGroup } from '@angular/forms';
import { AuthService } from '../../shared/services/auth.service';
import { UtilService } from '../../shared/services/util.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { CommonBookingService } from 'src/app/bookings/shared/common-booking.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { parseZone } from 'moment';
import moment from 'moment';
@Injectable()
export class CreateBookingService {
  
  public newRiders: any[] =  [];
  public isEditMode: boolean;
  public editConfigTimer: any;
  private destroy$ = new Subject();
  private approverEmail$ = new Subject();
  public approverEmail = this.approverEmail$.asObservable();
  private riderEmailForApproval = '';
  private showPopUp$ = new Subject();
  public showPopUp = this.showPopUp$.asObservable();

  private managerApprovalRequired$ = new Subject();
  public managerApprovalRequired = this.managerApprovalRequired$.asObservable();

  private showdialog$ = new Subject();
  public showdialog = this.showdialog$.asObservable();
  public approvalEmail = new BehaviorSubject<any>('');
  public riderGuid = new BehaviorSubject<any>([]);
  public riderCity = new BehaviorSubject<any>({city: '', selected: false});
  public uploadImgUrl = new BehaviorSubject<any>(null);
  public savedDocuments = new BehaviorSubject<any>([]);
  public selectedFilesObj = new BehaviorSubject<any>([]);
  public submittedDocId = new BehaviorSubject<string>("");
  public showCreateBookingButton = new BehaviorSubject<boolean>(true);
  public createBackDatedBooking = new BehaviorSubject<boolean>(false);
  public multiDayBooking = new BehaviorSubject<boolean>(false);
  public roundTrip = new BehaviorSubject<boolean>(false);
  public daysCount = new BehaviorSubject<number>(1);
  public preponeTripSheetInHours = new BehaviorSubject<string>('');
  public startTime = new BehaviorSubject<string>('');
  public endTime = new BehaviorSubject<string>('');
  public genderArrays = new BehaviorSubject<string[]>([]);
  public dateChange = new BehaviorSubject<string>(parseZone().format("DD/MM/YYYY"));
  public requestorForm = new BehaviorSubject<any>({selected: false, selectedUser: {}, selectedRequestor: ''});
  public getWhatsappNotify = new BehaviorSubject<boolean>(false);
  public escortConfig = new BehaviorSubject<any>({});
  public estimatedData = new BehaviorSubject<any>({});

  staticMapUrl:any

  constructor(private apiService: ApiService, private authService: AuthService,
    private utilService: UtilService, private commonService: CommonService,
    private http: HttpClient,
    private commonBookingService: CommonBookingService) {
    this.approverEmail.subscribe((res: string) => {
      this.riderEmailForApproval = res;
    });

  }

  public fetchEmployees(searchQuery: string): Observable<any[]> {
    return this.apiService.httpRequest({
      url: 'fetchEmployees',
      type: 'GET',
      queryParams: { searchQuery }
    });
  }


  setApproverEmail(email) {
    this.approverEmail$.next(email);
  }

  showApprovalManagerPopup() {
    this.showPopUp$.next();
  }

  isManagerApprovalRequired(value) {
    this.managerApprovalRequired$.next(value);
  }

  showWarningDialog(value) {
    this.showdialog$.next(value);
  }

  convertFormToRequestCard(formGroup: FormGroup) {
    const rawData = formGroup.getRawValue();
    const requestObject: any = {
      requestSource: 'Web'
    };
    if (!this.isEditMode) {
      requestObject.bookerBuid = this.authService.user.buId;
      requestObject.bookerGuid = this.authService.user.employeeGuid;
    }
    this.commonBookingService.selectedPayer.
      pipe(
        takeUntil(this.destroy$),
      )
      .subscribe((type) => {
        if (type) {
          requestObject.payerGuid = type;
        }
      });
    // extract requester object
    const requester = rawData.userDetails.requester;
    delete requester.Requester;
    requester.buid = this.authService.user.buId;
    requestObject.requester = requester;

    // create rider map
    const riders = rawData.userDetails.riders;
    const ridersMap: any = {};
    riders.forEach((rider: any) => {
      rider.buid = this.authService.user.buId;
      if (this.isEditMode && rider.travellerId.indexOf('SPOTFE') < 0) {
        rider.personId = rider.travellerId;
      } else {
        rider.uniqueEmpId = rider.travellerId;
      }
      delete rider.travellerId;
      if (rider.riderId) {
        delete rider.riderId;
      }
      if (rider.phonecode && rider.phonecode !== '+91') {
        rider.mobile = rider.phonecode + "-" + rider.mobile;
      }
      ridersMap[rider.uniqueEmpId || rider.personId] = rider;
    });

    // extract booking data
    const spotBookings: any[] = [];
    const dateCardArray = rawData.tripDetails.dateWise;
    const multiBookingRequest = dateCardArray.length > 1 || dateCardArray[0].dates.length || dateCardArray[0].CabCount;
    for (const dateCard of dateCardArray) {
      const cabsData: any[] = [];
      // add rider object to each stop
      for (const cab of dateCard.cabs) {
        const riderTrack = [];
        const riderDropTrack = [];
        const allRiders = [];
        const tempCab = this.utilService.deepCopy(cab);
        tempCab.vehicleType = tempCab.vehicleType === 'Other' ? tempCab.otherVehicleType : tempCab.vehicleType;
        delete tempCab.otherVehicleType;

        if (tempCab.vendor) {
          for (const vendor of this.commonService.etsData.vendors) {
            if (tempCab.vendor === vendor.guid) {
              tempCab.vendor = vendor;
              break;
            }
          }
        } else {
          tempCab.vendor = null;
        }

        for (let stopIndex = 0; stopIndex < tempCab.stops.length; stopIndex++) {
          const cabStop = tempCab.stops[stopIndex];
          cabStop.priorityOrder = stopIndex + 1;
          if (cabStop.address) {
            delete cabStop.address.isSaved;
            Object.assign(cabStop, {
              address: cabStop.address.address,
              geoCord: cabStop.address.geoCord,
              addressType: cabStop.address.type
            });
          }

          const travellers = [];
          if (cabStop.riders) {
            for (const rider of cabStop.riders) {
              if (!ridersMap[rider.name]) {
                continue;
              }
              if (rider.boardingType === 'PickUp') {
                riderTrack.push(rider.name);
              } else if (rider.boardingType === 'Drop') {
                riderDropTrack.push(rider.name);
              }
              allRiders.push(rider.name);
              const riderDetails = this.utilService.deepCopy(ridersMap[rider.name]);
              riderDetails.boardingType = rider.boardingType;
              if (this.isEditMode && rider.riderId) {
                riderDetails.riderId = rider.riderId;
              }
              travellers.push(riderDetails);
            }
          }
          cabStop.riders = travellers;

          switch (stopIndex) {
            case 0: cabStop.pointType = 'START'; break;
            case tempCab.stops.length - 1: cabStop.pointType = 'END'; break;
          }
        }

        const stopRiders = tempCab.stops[tempCab.stops.length - 1].riders;
        for (const riderId of riderTrack) {
          if (riderDropTrack.indexOf(riderId) < 0) {
            const riderObj = this.utilService.deepCopy(ridersMap[riderId]);
            riderObj.boardingType = 'Drop';
            stopRiders.push(riderObj);
          }
        }

        const startRiders = tempCab.stops[0].riders;
        for (const riderId of riderDropTrack) {
          if (riderTrack.indexOf(riderId) < 0) {
            const riderObj = this.utilService.deepCopy(ridersMap[riderId]);
            riderObj.boardingType = 'PickUp';
            startRiders.push(riderObj);
          }
        }

        if (!multiBookingRequest) {
          Object.keys(ridersMap).forEach((riderId: string) => {
            if (allRiders.indexOf(riderId) < 0) {
              const riderObj = this.utilService.deepCopy(ridersMap[riderId]);
              const riderObj2 = this.utilService.deepCopy(ridersMap[riderId]);
              riderObj.boardingType = 'Drop';
              stopRiders.push(riderObj);
              riderObj2.boardingType = 'PickUp';
              startRiders.push(riderObj2);
            }
          });
        }

        cabsData.push(tempCab);
      }

      // add datetime to each booking and stop

      for (const cab of cabsData) {
        const tempBooking = this.utilService.deepCopy(cab);
        tempBooking.startTime = [];
        for (const date of dateCard.dates) {
          tempBooking.startTime.push(this.utilService.convertToDateTimeString(date instanceof Array ? date[0] : date, tempBooking.stops[0].time));
        }
        for (const cabStop of tempBooking.stops) {
          if (cabStop.time) {
            cabStop.time = this.utilService.convertToDateTimeString(dateCard.dates[0] instanceof Array ? dateCard.dates[0][0] : dateCard.dates[0] , cabStop.time);
          }
        }
        if (cabsData.length === 1 && dateCard.CabCount > 1) {
          tempBooking.cabCount = dateCard.CabCount ;
        }

        // Add engagementCode data
        const manager = rawData.tripDetails.manager;
        const partner = rawData.tripDetails.partner;
        const billableType = rawData.tripDetails.billableType;
        const gstCode = rawData.tripDetails.gstCode;

        tempBooking.manager = manager || null;
        tempBooking.partner = partner || null;
        tempBooking.billableType = billableType || null;
        tempBooking.gstCode = gstCode || null;
        tempBooking.staticMapUrl = this.staticMapUrl
        if(this.estimatedData){
          this.estimatedData.subscribe(res=>{
            if(res){             
              tempBooking.stops.forEach(temp_stop => {
                res?.stops?.forEach(est_stop => {
                    if (est_stop.stopName === temp_stop.address) {
                        temp_stop.time = est_stop.estTime;
                    }
                });
            });
            }
          })
        }        
        spotBookings.push(tempBooking);
      }

    }

    requestObject.spotBookings = spotBookings;
    return requestObject;
  }

  public createStaticUrl(coordinates) {
    // Constructing the static map URL
    let localStaticMapURL = "https://maps.googleapis.com/maps/api/staticmap?";
    localStaticMapURL += "size=600x400&maptype=roadmap&zoom=auto&";

    localStaticMapURL += "style=feature:road.highway|element:labels|visibility:off&"; // Hide highway labels
    localStaticMapURL += "style=feature:road.local|element:labels|visibility:off&"; // Hide local road labels
    localStaticMapURL += "style=feature:poi|visibility:off&"; // Hide points of interest
    localStaticMapURL += "style=feature:transit|visibility:off&"; // Hide transit features


    // Add markers for each coordinate
    coordinates.forEach((coord,index) => {
      let markerIcon;
      if (coord.pointType === "START") {
        markerIcon = 'https://hmp.me/ce6u'; 
      } else if (coord.pointType === "END") {
        markerIcon = "https://maps.google.com/mapfiles/ms/micons/blue-dot.png";
      } else {
        markerIcon ='https://hmp.me/ce6v'; 
      }
      localStaticMapURL += `markers=icon:${markerIcon}|${coord.lat},${coord.lng}&`;

    });

    let path = "path=color:0x444444ff|weight:3";
    coordinates.forEach(coord => {
        path += `|${coord.lat},${coord.lng}`;
    });
    localStaticMapURL += path + "&";
    const apiKey = "AIzaSyBbmISgjYWEvdJIMsJMtxrPKM-pGxWHkm4";
    localStaticMapURL += `key=${apiKey}`;
    this.staticMapUrl=localStaticMapURL    
  }
 
  public convertFormToRequest(formGroup: FormGroup) {
    const request = this.convertFormToRequestCard(formGroup);
    const bookingsList = [];

    for (const booking of request.spotBookings) {
      const dateArray = booking.startTime;
      for (const date of dateArray) {
                const tempBooking = this.utilService.deepCopy(booking);
        tempBooking.paymentType = request.requester.paymentType;
        tempBooking.multiDays = tempBooking.multiDays || [];
        tempBooking['riderEmailForApproval'] = this.riderEmailForApproval;
        tempBooking.startTime = date;
        let startTime;
        for (let stopIndex = 0; stopIndex < tempBooking.stops.length; stopIndex++) {
          const stop = tempBooking.stops[stopIndex];
          if (!stop.time) {
            continue;
          }
          const prevStop = stopIndex > 0 && booking.stops[stopIndex - 1];
          if (!prevStop) {
            stop.time = tempBooking.startTime.split(' ')[0] + ' ' + stop.time.split(' ')[1];
          } else {
            const stopHours = stop.time.split(/ |\//)[3];
            const prevHours = prevStop.time.split(/ |\//)[3];
            if (prevHours > 12 && stopHours < 12) {
              stop.time = tempBooking.startTime.split(' ')[0] + ' ' + stop.time.split(' ')[1];
              const dateObj  = this.utilService.getMoment(stop.time);
              const nextDateObj = dateObj.add(1, 'days');
              stop.time = this.utilService.convertMomentToDateTimeString(nextDateObj);
            } else {
              stop.time = tempBooking.startTime.split(' ')[0] + ' ' + stop.time.split(' ')[1];
            }
          }
          if(stopIndex==0) startTime = moment(stop.time, "DD/MM/YYYY HH/mm/ss");
          else {
            let stopTime = moment(stop.time, "DD/MM/YYYY HH/mm/ss");
            if (stopTime.isBefore(startTime)) {
              stopTime.add(1, 'day');
              tempBooking.stops[stopIndex].time = stopTime.format("DD/MM/YYYY HH/mm/ss");
          }
          }
        }
        this.approvalEmail.subscribe((email) => {
          tempBooking.customApproveEmail = email;
        });
        this.submittedDocId.subscribe(res => tempBooking.documentId = res);
        this.createBackDatedBooking.subscribe(res => tempBooking.backDatedBooking = res);
        this.getWhatsappNotify.subscribe(res => tempBooking.whatsappCommunication = res);
        this.multiDayBooking.subscribe(res => {
          if (res){
            tempBooking.multiDayBooking = res;
            tempBooking.noOfDays = tempBooking.multiDays?.length + 1;
            tempBooking.multiDays.forEach(day => {
              day.stops.forEach((stop: any, index: number) => {
                if (stop.address instanceof Object){
                  const { address, addressType, geoCord } = stop.address;
                  stop.address = address;
                  stop.addressType = addressType;
                  stop.geoArea = stop.geoArea;
                  stop.geoCord = geoCord;
                  stop.priorityOrder = index + 1;
                }
              });
            });
          }
        });
        this.roundTrip.subscribe(res=>tempBooking.roundTrip=res)

        if (booking.cabCount > 1) {
          const cabCount = booking.cabCount;
          for (let cabIndex = 0; cabIndex < cabCount; cabIndex++) {
            bookingsList.push(tempBooking);
          }
        } else {
          bookingsList.push(tempBooking);
        }
      }
    }
    // handle seperate time and date
    request.spotBookings = bookingsList;
    return request;
  }

  public addRiderIdToEndStop(booking, referenceBooking) {
    const bookingRiders =  booking.stops[booking.stops.length - 1].riders;
    const refRiders = referenceBooking.stops[referenceBooking.stops.length - 1].riders;

    bookingRiders.forEach((bookingRider) => {
      for (const refRider of refRiders) {
        if (bookingRider.personId === refRider.personId) {
          bookingRider.riderId = refRider.riderId;
          break;
        }
      }
    });
  }

  getRateCard(searchQuery) {
    return this.apiService.httpRequestBlob({
      url: 'viewRateCard',
      type: 'GET',
      queryParams: searchQuery
    });
  }

  fetchManageApprovalWorkflowConfig() {
    return this.apiService.httpRequest({
      url: 'fetchManageApprovalConfig',
      type: 'GET',
      queryParams: {
        buid: this.authService.user.buId,
        client: this.authService.client.client
      }
    });
  }

  fetchEmailListOfManagers(body) {
    return this.apiService.httpRequest({
      url: 'getApproverDetails',
      type: 'POST',
      body,
      queryParams: {
        buid: this.authService.user.buId,
        client: this.authService.client.client
      }
    })
  }
  fetchEstimateData(body,cabType,bookingType,city){
    return this.apiService.httpRequest({
      url: 'estimatedDataCall',
      type: 'POST',
      body,
      queryParams: {
        bookingType:bookingType,
        city:city,
        cabType:cabType

      }
    })
  }

  uploadRateCard(request, searchQuery) {
    const postData = new FormData();
    postData.append('uploadratecard', request.uploadFile);
    return this.apiService.httpRequestBlob({
      url: 'uploadRateCard',
      type: 'POST',
      body: postData,
      queryParams: searchQuery,
      fileUpload: true
    });
  }

  public createBooking(request: any): any  {
    return this.apiService.httpRequest({
      url: 'createBooking',
      type: 'POST',
      body: request
    });
  }

  public getPaymentConfig(): any  {
    return this.apiService.httpRequest({
      url: 'getPaymentConfig',
      type: 'GET',
      queryParams: {
        buid: this.authService.user.buId,
        client: this.authService.client.client
      }
    });
  }

  fetchCardDetails(request: any) {
    return this.apiService.checkResponseStatus({
      url: 'fetchCardDetails',
      type: 'POST',
      body: request
    });
  }

  public updateBooking(queryParams, booking: any): Observable<any>  {
    return this.apiService.httpRequest({
      url: 'updateBooking',
      type: 'PUT',
      body: booking,
      queryParams
    });
  }
  public fetchEscortConfig(): any  {
    return this.apiService.httpRequest({
      url: 'fetchEscortConfig',
      type: 'GET',
      queryParams: {
        buid: this.authService.user.buId,
        client: this.authService.client.client,
        empGuid: this.authService.user.employeeGuid
      }
    });
  }

  public saveDocuments(request, bookingId){
    const postData = new FormData();
    for (let i = 0; i < request.files.length; i++) {
      postData.append('files', request.files[i]);
    }
    postData.append("bookingId", bookingId);
    const url = `${environment.apiBaseUrl}spot/uploadDoc`;
    return this.http.post(url, postData);
  }

  calculateBookingEditConfig = (booking, editConfig) => {
    const config: any = {};
    config.pickUpTime = editConfig.pickUpTime;
    if (booking.cabAllocStatus === 'ALLOCATED' || booking.cabAllocStatus === 'FINALIZED') {
      config.status = 'cabAssigned';
    } else if (booking.managerStatus === 'PENDING') {
      config.status = 'approvalPending';
    }  else if (booking.vendorAllocStatus === 'ASSIGNED') {
      config.status = 'vendorAssigned';
    } else {
      config.status = 'nothingAssigned';
    }
    let minTimeDiff = 0;
    const categoryInfo = editConfig.status[config.status];
    const categoryList = Object.keys(categoryInfo);
    for (const category of categoryList) {
      const cutoff = Number(categoryInfo[category].cutoff);
      const diffInMins = this.utilService.findTimeDiffInMinutes(booking.startTime);
      const diffFromCutoff = Math.floor(diffInMins - cutoff);
      config[category] = diffInMins > cutoff ? diffFromCutoff : 0;
      if (!minTimeDiff || minTimeDiff > diffFromCutoff) {
        minTimeDiff = diffFromCutoff;
      }
    }
    config.minTimeDiff = minTimeDiff;
    return config;
  }

  reevaluateConfig = (booking, editConfig, observer) => {
    const bookingEditConfig = this.calculateBookingEditConfig(booking, editConfig);
    observer.next(bookingEditConfig);
    if (bookingEditConfig.minTimeForRecheck > 0) {
      this.editConfigTimer = setTimeout(() => {
        this.reevaluateConfig(booking, editConfig, observer);
      }, bookingEditConfig.minTimeDiff);
    } else {
      observer.complete();
    }
  }

  public getBookingEditConfig(booking: any, editConfig: any): Observable<any> {
    return new Observable((observer) => {
      this.reevaluateConfig(booking, editConfig, observer);
    });
  }

  public getRequesters(){
    return this.apiService.httpRequest({
      url: 'fetchRequesters',
      type: 'GET',
      queryParams: {
        client: this.authService.client.client
        }
    });

  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
